import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import SummarySectionTitle from './Component/SummarySectionTitle';
import SummaryFeature from './Component/SummaryFeature';
import { currencyFormatter } from '../../utils/currencyFormatter';

const SummarySectionsList = () => {
  const sections = useSelector(state => state.configurator.sections);
  const rooms = useSelector(state => state.configurator.rooms);
  const categories = useSelector(state => state.configurator.categories);
  const totalPrice = useSelector(state => state.configurator.totalPrice);
  const userLoggedIn = useSelector(state => state.configurator.userLoggedIn);

  return (
    <div className="summary-sections-list">
      <div className="summary-sections-list-header">
        <div className="title">Su configuración</div>
        {/* <span>|</span>
        <div className="flat-name">{userFlat}</div> */}
      </div>

      {/* eslint-disable-next-line max-len */}
      <div className="description">A continuación se muestra un resumen de las opciones que ha seleccionado:</div>
      {/* <div className={`container-sections${userLoggedIn ? ' logged-in' : ''}`}> */}
      <div className="container-sections">
        {
                  rooms !== undefined && rooms.map((room, index) => (
                    <>
                      <SummarySectionTitle title={room.name} />
                      <div className="summary-feature-container">
                        {
                          room.categories.map((roomCategory, index2) => {
                              const category = categories.find(cat => cat.id === roomCategory.id);

                              if (category.features !== undefined && category.features.length > 0) {
                                  const selectedFeature = category.features.find(
                                      feature => feature.id === category.selected_feature,
                                  );
                                  if (selectedFeature !== undefined) {
                                      return (
                                        <SummaryFeature
                                          categoryName={category.name}
                                          feature={selectedFeature}
                                          disabled={category.disabled}
                                        />
                                      );
                                  }
                              }
                              return null;
                          })
                        }
                      </div>
                    </>
                  ))
              }
        {/* sections !== undefined && sections.map((section, index) => (
          <>
            <SummarySectionTitle title={section.name} />
            <div className="summary-feature-container">
              {
                section.categories.map((category, index2) => {
                  if (category.features !== undefined && category.features.length > 0) {
                    return (
                      <SummaryFeature
                        categoryName={category.name}
                        feature={category.features.find(feature => feature.id === category.selected_feature)}
                      />
                    );
                  }
                  return null;
                })
              }
            </div>
          </>
        )) */}
      </div>
      {/* userLoggedIn ? ( */}
      <div className="total-price-summary-container">
        <div className="divider" />
        <div className="total-price-row">
          <div className="title">PRECIO TOTAL (SIN IVA)</div>
          <div className="value">{currencyFormatter.format(totalPrice)}</div>
        </div>

      </div>
      {/* }) : null} */}
    </div>
  );
};

export default SummarySectionsList;
